<!-- home.component.html -->
<div class="w-full min-h-screen bg-gray-50 text-gray-900" dir="rtl">
  <div class="w-full mx-auto px-4 sm:px-6 py-6" *ngIf="page$ | async as page">

    <h1 class="text-2xl sm:text-3xl font-bold tracking-tight mb-6">
      <a class="title-to-video" href="{{ page?.url }}" target="_blank">
      {{ page.title }}
     </a>
    </h1>

    <section>
      <article
      *ngFor="let a of page.articles; let i = index; trackBy: trackById"
      class="bg-white border border-gray-200 rounded-2xl p-4 sm:p-6 shadow-sm">

        <!-- Desktop/tablet layout: 25% / 2% / 73% -->
        <div class="hidden sm:flex items-start">
          <!-- Left: image column (25%) -->
          <div class="w-[25%]">
            <div
            *ngFor="let img of a.images; trackBy: trackByIndex"
            class="img-ph" role="img" aria-label="Image placeholder">
              <a href="{{ a?.url }}" target="_blank">
              <img src="assets/images/{{ img }}" alt="{{ a.title }}" class="w-full h-full object-cover" />
              </a>
            </div>
          </div>

          <!-- Gap (2%) -->
          <div class="w-[2%]"></div>

          <!-- Right: text column (73%) -->
          <div class="w-[73%]">
            <h2 class="text-lg sm:text-xl font-semibold mb-2">
              {{ a.title }}
            </h2>
            <p class="text-sm sm:text-base leading-relaxed text-gray-700  whitespace-pre-line">{{ a.text }}</p>

            <p class="mt-5" align="center">
               <a class="link-to-video" [href]="'mailto:' + a?.email" target="_blank">📩 שלח מייל to:{{ a?.email }}</a>
            </p>
          </div>
        </div>

        <!-- Mobile layout: stacked -->
        <div class="sm:hidden">
          <div class="w-full flex flex-col gap-3">
              <div
                *ngFor="let img of a.images; trackBy: trackByIndex"
                class="img-ph"
                role="img"
                aria-label="Image placeholder"
              >
                <a href="{{ a?.url }}" target="_blank">
                  <img src="assets/images/{{ img }}" alt="{{ a.title }}" class="w-full h-full object-cover" />
                </a>
              </div>

              <div class="w-full">
                  <h2 class="text-lg font-semibold mb-2">
                    {{ a.title }}
                  </h2>
                  <p class="text-sm leading-relaxed text-gray-700  whitespace-pre-line">
                    {{ a.text }}
                  </p>

                <p class="mt-5" align="center">
                  <a class="link-to-video" [href]="'mailto:' + a?.email" target="_blank">📩 שלח מייל to:{{ a?.email }}</a>
                </p>
              </div>
          </div>
        </div>

      </article>
    </section>

  </div>
</div>
